import {Card, CardBody} from "reactstrap";
import React from "react";
import {useTranslation} from "react-i18next";

export const UserOrgRoles = ({ data, isSuperAdmin = null}) => {
    const { t } = useTranslation();

    // Agrupar roles por organización
    const groupedByOrg = data.reduce((acc, item) => {
        const orgKey = item.orgId || 'unknown';
        if (!acc[orgKey]) {
            acc[orgKey] = {
                orgId: item.orgId,
                orgName: item.orgName,
                orgType: item.orgType,
                roles: []
            };
        }
        acc[orgKey].roles.push({
            id: item.id,
            role: item.role,
            permissions: item.permissions || []
        });
        return acc;
    }, {});

    const organizations = Object.values(groupedByOrg);

    return (
        <Card className="mb-3 card-backend">
            <CardBody>
                <h5 className="mb-3 text-green fw-bold">{t('role.orgRoles')}</h5>
                
                {organizations.map((org, orgIndex) => (
                    <div key={`org-${org.orgId}-${orgIndex}`} className={orgIndex > 0 ? "mt-4 pt-3 border-top" : ""}>
                        {/* Organization title */}
                        {org.orgName && org.orgType && (
                            <div className="mb-3">
                                <h6 className="fw-bold mb-1">
                                    {org.orgName} <span className="text-muted fw-normal">({org.orgType})</span>
                                </h6>
                                {isSuperAdmin && (
                                    <small className="text-muted" style={{fontSize: '0.75rem', opacity: 0.7}}>
                                        <i className="mdi mdi-information-outline me-1"></i>
                                        {t('modelLabel.orgId')}: {org.orgId}
                                    </small>
                                )}
                            </div>
                        )}

                        {/* Column headers */}
                        <div className="d-flex flex-column flex-md-row mb-2 fw-semibold">
                            <div className="flex-shrink-0" style={{minWidth: '200px'}}>
                                {t('role.role')}:
                            </div>
                            <div className="flex-grow-1 ms-md-4">
                                {t('role.permissions')}:
                            </div>
                        </div>

                        {/* Role list */}
                        {org.roles.map((roleItem, roleIndex) => (
                            <div key={`role-${roleItem.id}-${roleIndex}`} className={roleIndex > 0 ? "mt-2" : ""}>
                                <div className="d-flex flex-column flex-md-row">
                                    {/* Role on the left */}
                                    <div className="flex-shrink-0 mb-2 mb-md-0" style={{minWidth: '200px'}}>
                                        <div className="text-muted">{roleItem.role}</div>
                                        {isSuperAdmin && (
                                            <small className="text-muted" style={{fontSize: '0.75rem', opacity: 0.7}}>
                                                <i className="mdi mdi-information-outline me-1"></i>
                                                {t('modelLabel.id')}: {roleItem.id}
                                            </small>
                                        )}
                                    </div>

                                    {/* Permissions on the right */}
                                    <div
                                        className="flex-grow-1 ms-md-4 text-muted"
                                        style={{ minWidth: 0, whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' }}
                                    >
                                        {roleItem.permissions.length > 0 ? roleItem.permissions.join(', ') : ''}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </CardBody>
        </Card>
    );
}